import { endpoint } from "../../../common/constant";
import { fetchAllPostPromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const getProgramActionTreeApi = async () => {
  const url = `${endpoint.programActionUpdate.getProgramActionTree}`;
  return fetchAllPromisedData(url);
};

export const getProgramActionReasonApi = async () => {
  const url = `${endpoint.programActionUpdate.getProgramActionReasonMapping}`;

  return fetchAllPromisedData(url);
};

export const updateProgramActionApi = async (request) => {
  const url = `${endpoint.programActionUpdate.updateProgramAction}`;
  return fetchAllPostPromisedData(url, request, "PUT");
};

export const getProgramActionHistory = (application) => {
  const endPoint = `${endpoint.programActionUpdate.getHistory}/${application}`;
  return fetchAllPromisedData(endPoint);
};

export const getDiscontinueFeedbacks = async(application) => {
  const endPoint = `${endpoint.programActionUpdate.getDiscontinueFeedback}/${application}`;
  return fetchAllPromisedData(endPoint, true);
};
